import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { popupcontext } from "../../context/Popupscontext";
import SecondHeader from "../Header/SecondHeader";
import Table from "../Helpers/Table/Table";
import Loader from "../Helpers/Loader/Loader";
import NotificationHead from "./NotificationParts/NotificationHead";
import NotificationForm from "./NotificationForm/NotificationForm";
import { useGetAllNotificationsQuery } from "../../Redux/service/Notifications/Notifications";
import { filtrationcontext } from "../../context/Filtercontext";
import { toast } from "react-toastify";
import trans, { isRTL } from "../../utils";
import Actions from "../antd/Table/Actions";
import AntdTable from "../antd/Table/Table";
import usePermission from "../../hooks/usePermission";

export default function Notification() {
	const { handleShow, setEdited, deleteItem, setDeleteItem } =
		useContext(popupcontext);
	const { setSearchQuery } = useContext(filtrationcontext);
	const HeadField = [trans("Type"), trans("Actions")];
	let { data, isLoading, refetch, isError } = useGetAllNotificationsQuery();
	const { create, edit, delete: canDelete } = usePermission("CONFIGURATION");

	let getAlertType = (type) => {
		if (type === "deviceOverspeed") {
			return "Speed Alert";
		} else if (type === "geofenceExit") {
			return "Geofence exited";
		} else if (type === "geofenceEnter") {
			return "Geofence entered";
		} else if (type === "deviceFuelDrop") {
			return "Fuel drop";
		} else if (type === "deviceFuelIncrease") {
			return "Fuel increase";
		} else if (type === "idle") {
			return "Vehicle Idle";
		} else {
			return type;
		}
	};
	const Columns = [
		{
			title: trans("Type"),
			dataIndex: "type",
			width: 150,
			fixed: !isRTL ? "left" : undefined,
			render: (name) => (
				<span className={"table-element-name ps-0"}>{getAlertType(name)}</span>
			),
		},

		{
			title: trans("Actions"),
			width: 150,
			fixed: !isRTL ? "right" : undefined,
			render: ({ id }) => (
				<Actions
					notifiyid={id}
					canAddTask={create}
					canEdit={edit}
					canDelete={canDelete}
				/>
			),
		},
	];
	const handleSuccess = (newnotification) => {
		if (newnotification) {
			setEdited(true);
			refetch();
		}
	};
	useEffect(() => {
		async function fetchdata() {
			if (
				deleteItem.condition === true &&
				deleteItem.value === "notifications"
			) {
				await refetch();
				setDeleteItem({ condition: null, value: null });
			}
		}
		fetchdata();
	}, [deleteItem.condition, deleteItem.value, refetch, setDeleteItem]);
	useEffect(() => {
		return () => setSearchQuery("");
	}, [setSearchQuery]);
	if (isError)
		return toast.error(trans("Please try again"), {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});
	return (
		<div>
			<Helmet>
				<title>Notifications</title>
				<meta name="description" content="Notifications" />
			</Helmet>
			<SecondHeader
				title={trans("configuration")}
				add={create ? trans("Add notification") : null}
				onClick={() => handleShow("addForm")}
			/>
			<NotificationHead />
			{isLoading ? (
				<>
					<div className="loader-container loader-table">
						<Loader />
					</div>
				</>
			) : (
				<div className="bg-white-rounded-top table-parent">
					<AntdTable
						columns={Columns}
						dataSource={data || []}
						loading={isLoading}
						paginationValue={true}
					/>
				</div>
			)}
			<NotificationForm onSuccess={handleSuccess} />
		</div>
	);
}
